import { useEffect, useState } from 'react';
import { api } from './api';

let cache = null;
let inflight = null;

const rows = ({ doctrines, documents, books }) => {
  const out = [];
  doctrines.forEach((d) => out.push({ id: `doc-${d.slug}`, kind: 'Doctrine', number: d.number, title: d.title, route: `/u99/doctrines/${d.slug}`, words: d.word_count || 0, live: d.status !== 'draft' }));
  documents.forEach((d) => out.push({ id: `pub-${d.slug}`, kind: d.body_format === 'text' ? 'Publication' : (d.category === 'novel' ? 'Novel' : d.category === 'thesis' ? 'Thesis' : d.category === 'manuscript' ? 'Manuscript' : 'Document'), title: d.title, route: `/u99/documents/${d.slug}`, words: d.word_count || 0, live: true, order: d.publication_order }));
  books.forEach((b) => {
    out.push({ id: `book-${b.slug}`, kind: 'Book', title: b.title, route: `/u99/book/${b.slug}`, words: (b.chapters || []).reduce((n, c) => n + (c.word_count || 0), 0), live: true, chapters: b.chapters?.length || 0 });
    (b.chapters || []).forEach((c) => out.push({ id: `ch-${b.slug}-${c.slug}`, kind: 'Chapter', number: c.number, title: `${b.title} · ${c.title}`, route: `/u99/book/${b.slug}/${c.slug}`, words: c.word_count || 0, live: true }));
  });
  return out;
};

export const useLibrary = () => {
  const [lib, setLib] = useState(cache);
  useEffect(() => {
    if (cache) return;
    inflight = inflight || Promise.all([api.get('/doctrines'), api.get('/documents'), api.get('/books')]).then(([d, p, b]) => {
      cache = { doctrines: d.data, documents: p.data, books: b.data, rows: rows({ doctrines: d.data, documents: p.data, books: b.data }) };
      return cache;
    });
    inflight.then(setLib).catch(() => setLib({ doctrines: [], documents: [], books: [], rows: [] }));
  }, []);
  return lib;
};

export const isDiscoveryAttribute = (d) => /^DISCOVERY ATTRIBUTE/.test(d.title);
export const ELI_ELY_SLUG = 'eli-and-ely-the-split-part-one';
